import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { useSelector } from "react-redux"
import { useAppDispatch } from "lib/store"
import { toggleEditSidebar } from "lib/store/services/editSidebar/slice"
import { editSidebarOpen } from "lib/store/services/editSidebar/selectors"

import { ALL_TAX_PROVIDERS } from "graphql/queries/config/Providers/TaxJar/AllTaxProviders"

import PageHeader from "components/Ui/Page/PageHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import { CreateTaxJarConfig } from "./CreateTaxJarConfig"
import { EditTaxJarConfig } from "./EditTaxJarConfig"

import { ReactComponent as PlusIcon } from "images/icons/plus.svg"
import { TaxJarConfigTable } from "../../../../components/Config/TaxJar/TaxJarConfigTable"
import { WithAuth } from "../../../../components/Auth"
import { ReactComponent as TaxJarLogo } from "images/providers/tax-jar-logo.svg"
import { PermissionGroups } from "../../../../routes/constants"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const PageTaxJarLogo = styled(TaxJarLogo)`
  height: 2.5rem;
  max-width: 9rem;
`

export const TaxJarConfiguration = () => {
  const [editId, setEditId] = useState<string>("")
  const isSidebarOpen = useSelector(editSidebarOpen)
  const { loading, data, refetch, error } = useQuery(ALL_TAX_PROVIDERS)
  const taxProviders = data?.getTaxProviders
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isSidebarOpen) {
      setEditId("")
    }
  }, [isSidebarOpen])

  return (
    <Container>
      <PageHeader
        title={<PageTaxJarLogo/>}
        description="Manage your TaxJar configurations"
        goBackLinkText="Back to providers"
        goBackLinkUrl={"/settings/providers"}
      >
        <WithAuth requiredGroups={PermissionGroups.providers.write}>
          <PrimaryButton type="button" handleClick={() => dispatch(toggleEditSidebar())}>
            <PlusIcon /> Add new configuration
          </PrimaryButton>
        </WithAuth>
      </PageHeader>
      {!editId && <CreateTaxJarConfig refetch={refetch} />}
      {editId && (
        <EditTaxJarConfig editId={editId} setEditId={setEditId} refetch={refetch} />
      )}
      <TaxJarConfigTable
        providers={taxProviders}
        error={error}
        setEditId={setEditId}
        loading={loading}
      />
    </Container>
  )
}
